"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.VolumeBar = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("@xstate/react");
var video_context_1 = require("../../context/video-context");
var selectors_1 = require("../../selectors");
var slider_1 = require("@reach/slider");
var VolumeBar = function (_a) {
    var isActive = _a.isActive, props = __rest(_a, ["isActive"]);
    var className = props.className, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave;
    var videoService = (0, video_context_1.useVideo)();
    var volume = (0, react_1.useSelector)(videoService, selectors_1.selectVolume);
    var muted = (0, react_1.useSelector)(videoService, selectors_1.selectMuted);
    function getVolume() {
        if (muted) {
            return 0;
        }
        return volume;
    }
    function checkMuted() {
        if (muted) {
            videoService.send('TOGGLE_MUTE');
        }
    }
    function formattedVolume(value) {
        return (value * 100).toFixed(0) + "% ".concat(muted ? 'volume muted' : 'volume');
    }
    return (React.createElement(slider_1.SliderInput, __assign({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, min: 0, max: 1, value: getVolume(), defaultValue: getVolume(), step: 0.05, handleAlignment: "contain", getAriaValueText: function (value) { return formattedVolume(muted ? volume : value); }, "aria-label": "volume slider", onChange: function (newValue) {
            checkMuted();
            videoService.send({ type: 'VOLUME_CHANGE', volume: newValue });
        }, className: (0, classnames_1["default"])(className, 'cueplayer-react-volume-bar') }, props), function (_a) {
        var hasFocus = _a.hasFocus;
        var isVisible = hasFocus || isActive;
        return (React.createElement(slider_1.SliderTrack, { className: (0, classnames_1["default"])('cueplayer-react-volume-slider', {
                'cueplayer-react-volume-slider-active': isVisible
            }) },
            React.createElement(slider_1.SliderRange, null),
            React.createElement(slider_1.SliderHandle, null)));
    }));
};
exports.VolumeBar = VolumeBar;
